// extracted by mini-css-extract-plugin
module.exports = {"header":"ResultPage_header__1SDyZ","nav":"ResultPage_nav__3RKs6","footer":"ResultPage_footer__Vtaxr"};